<template>
  <div>
    <vx-card v-show="isCardActiveLocal" class="w-full mb-4" title="Snapshots">
      <vs-button v-show="isSnapshotListHidden" class="mr-4 vs-con-loading__container cursor-pointer" color="success" @click="listSnapshots" >Load Snapshots for this Task</vs-button>
      <vs-table v-show="!isSnapshotListHidden" ref="snapshotTable" stripe class="vs-con-loading__container" single @selected="handleSelectedSnapshot" pagination :max-items="snapshotsPerPage" :data="snapshots">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
              <span class="mr-2">{{ currentPage * snapshotsPerPage - (snapshotsPerPage - 1) }} - {{ snapshots.length - currentPage * snapshotsPerPage > 0 ? currentPage * snapshotsPerPage : snapshots.length }} of {{ snapshots.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="snapshotsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="snapshotsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="snapshotsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="snapshotsPerPage=25">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="snapshotsPerPage=50">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="snapshotsPerPage=100">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th>Image</vs-th>
          <vs-th sort-key="createdOn">Created On</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="snapshot" :key="indextr" v-for="(snapshot, indextr) in data">

            <vs-td>
              <img :src="snapshot.imageUrl" width=180px class="product-img" />
            </vs-td>

            <vs-td>
              {{ snapshot.createdOn.replace("T", " ").split('.')[0] }}
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

  </div>
</template>

<script>
  export default {
    components: {
      
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        loadingColor:'#fff',
        selected: [],
        snapshotsPerPage: 10,
        isMounted: false,
        isSnapshotListHidden: true,
        modules: [],
        snapshots: [],
        studentTasks: [],
        formData: {
          id: 0,
          description: ""
        },
        mode: ""
      }
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          
        }
      },
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.initValues();
          }
        }
      },
      currentPage() {
        if (this.isMounted) {
          return this.$refs.snapshotTable.currentx;
        }
        return 0;
      },
      isDisabled: function() {
        return !(this.formData.description);
      }
    },
    methods: {
      initValues() {
        this.formData.id = 0;
        this.formData.description = "";
        this.mode = "";
        this.isSnapshotListHidden = true;
        this.errors.clear();
      },
      getStatusColor(statusId) {
        var self = this;
        if(statusId == 1)
          return 'primary';
        else if(statusId == 2 || statusId == 3)
          return 'success';
        else if(statusId == 4)
          return 'danger';
        else if(statusId == 5)
          return 'warning';
      },
      listSnapshots() {
        const self = this;
        self.isSnapshotListHidden = false;
        self.showLoadingOnSnapshotsTable();

        var onSuccess = function (response) {
          self.snapshots = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.snapshotTable.$el);
        };

        self.$ajaxGet(self, "assessor/GetSnapshotsForLog/" + self.$route.query.TaskLogId, onSuccess, onFinally);
      },
      clearSnapshots() {
        var self = this;
        self.snapshots = [];
        self.isSnapshotListHidden = true;
      },
      handleSelectedSnapshot(snapshot) {
        var self = this;
        window.open(snapshot.imageUrl, "Title", "width=500, height=500");
      },
      showLoadingOnSaveButton(){
        var self = this;
        self.$vs.loading({
          background: self.loadingColor,
          type: "material",
          container: self.$refs.saveEditButton.$el,
          scale: 0.45
        });
      },
      showLoadingOnSnapshotsTable(){
        var self = this;
        self.$vs.loading({
          type: "corners",
          container: self.$refs.snapshotTable.$el,
          scale: 1
        });
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
    },
    mounted() {
      var self = this;
      self.isMounted = true;
      self.wasSidebarOpen = self.$store.state.reduceButton;
      self.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    },
    beforeDestroy() {
      if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
    }
  }

</script>
